<template>
  <div>
    <strong :id="'tooltip-target-' + rnd" :class="carriers.filter(x => x.id).length === order.meta?.shippings?.length ? 'text-success' : carriers.filter(x => x.id).length !== 0 ? 'text-warning' : 'text-danger'">{{carriers.filter(x => x.id).length}}/{{order.meta?.shippings?.length || order.shippings_amount}}</strong>
    <b-tooltip :target="'tooltip-target-' + rnd" triggers="hover" boundary-padding="20" v-if="carriers.filter(x => x.id).length">
      <div class="text-left">
        <div v-for="carrierId in Object.keys(carriersCount)" class="mb-2" v-if="carrierId !== 'undefined'" :key="order.id + carrierId">
          <strong>{{carriers.find(x => x.id + '' === carrierId)?.external_id || carriers.find(x => x.id + '' === carrierId)?.name || carriers.find(x => x.id + '' === carrierId)?.id}} × {{carriersCount[carrierId]}}</strong>
          <span v-if="carriers.find(x => x.id + '' === carrierId)?.name">
            <br>
            <span class="badge" :style="'background-color: ' + stringToColour(' ' + carriers.find(x => x.id + '' === carrierId).id + carriers.find(x => x.id + '' === carrierId).id + carriers.find(x => x.id + '' === carrierId).id + carriers.find(x => x.id + '' === carrierId).id + carriers.find(x => x.id + '' === carrierId).id) + ';' + textContrastColor(stringToColour(' ' + carriers.find(x => x.id + '' === carrierId).id + carriers.find(x => x.id + '' === carrierId).id + carriers.find(x => x.id + '' === carrierId).id + carriers.find(x => x.id + '' === carrierId).id + carriers.find(x => x.id + '' === carrierId).id))">
              {{carriers.find(x => x.id + '' === carrierId).name}}
            </span>
          </span>
        </div>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ShippingOrdersListItemExternalId',
  props: {
    order: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      rnd: Math.random(),
      carriers: [],
      carriersCount: {}
    }
  },
  mounted() {
    this.carriers = this.order.meta?.shippings?.map(x => x.courier_company || null).filter(Boolean)
    if (this.order.courier_company_id && this.carriers.length === 0) {
      this.order.meta.shippings = this.order.meta.shippings.map(x => {
        x.courier_company_id = this.order.courier_company_id
        x.courier_company = {
          id: this.order.courier_company.id,
          external_id: this.order.courier_company.external_id,
          name: this.order.courier_company.name
        }
        return x
      })
    }
    this.carriers = this.order.meta?.shippings?.map(x => x.courier_company || null).filter(Boolean) || []
    if (this.carriers.length) {
      this.carriersCount = this.filterArr(this.carriers, 'id')
    }
  },
  methods: {
    filterArr(data, key) {
      return data.reduce((result, current) => {
        if (!result[current[key]]) {
          result[current[key]] = 1
        } else {
          result[current[key]] += 1
        }
        return result
      }, {})
    }
  }
}
</script>
